import {
  ChevronDown,
  Download,
  FileSpreadsheet,
  FileText,
} from 'lucide-react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/ui/dropdown-menu';

export type YardGateExportFormat = 'csv' | 'xlsx';

interface ExportMenuProps {
  disabled: boolean;
  onExport: (format: YardGateExportFormat) => void;
}

export const ExportMenu = ({ disabled, onExport }: ExportMenuProps) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <button
        type="button"
        disabled={disabled}
        className="inline-flex h-9 items-center gap-2 rounded-md border border-green-600 bg-green-600 px-4 text-xs font-semibold text-white transition hover:border-green-500 hover:bg-green-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      >
        <Download size={14} aria-hidden />
        Exportar
        <ChevronDown size={14} aria-hidden />
      </button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="w-44 bg-white">
      <DropdownMenuItem onSelect={() => onExport('xlsx')}>
        <FileSpreadsheet className="mr-2 h-4 w-4" aria-hidden />
        Excel (.xlsx)
      </DropdownMenuItem>
      <DropdownMenuItem onSelect={() => onExport('csv')}>
        <FileText className="mr-2 h-4 w-4" aria-hidden />
        CSV (.csv)
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
